export const namespaced = true;

import StudentService from '@/services/StudentService.js';
import moment from 'moment-timezone';

export const state = {
  student: {},
  messagingHistory: [],
  learningHistory: [],
  wrongAnswerImages: [],
  messageType: {
    normal: 'normal',
    promoted: 'promoted',
  },
  notPromotedBooks: [
    {
      id: 0,
      bookId: null,
      bookName: null,
      bookPartId: null,
      bookPartName: null,
      bookChapterId: null,
      bookChapterName: null,
      bookBigQuestionId: null,
      bookBigQuestionName: null,
    },
  ],
};

export const mutations = {
  SET_STUDENT(state, student) {
    state.student = student;
  },
  UPGRADE_STUDENT_LEVEL(state, level) {
    state.student.level = level;
  },
  SET_MESSAGING_HISTORY(state, messagingHistory) {
    state.messagingHistory = messagingHistory;
  },
  SET_LEARNING_HISTORY(state, learningHistory) {
    state.learningHistory = learningHistory;
  },
  SET_WRONG_ANSWER_IMAGES(state, wrongAnswerImages) {
    state.wrongAnswerImages = wrongAnswerImages;
  },
  SET_NOT_PROMOTED_BOOK_AT_INDEX(state, payload) {
    state.notPromotedBooks.splice(payload.index, 1, payload.notPromotedBook);
  },
  ADD_NOT_PROMOTED_BOOK(state, notPromotedBook) {
    state.notPromotedBooks.push(notPromotedBook);
  },
  DELETE_NOT_PROMOTED_BOOK_AT_INDEX(state, index) {
    state.notPromotedBooks.splice(index, 1);
  },
  CLEAR_NOT_PROMOTED_BOOKS(state) {
    state.notPromotedBooks = [
      {
        id: 0,
        bookId: null,
        bookName: null,
        bookPartId: null,
        bookPartName: null,
        bookChapterId: null,
        bookChapterName: null,
        bookBigQuestionId: null,
        bookBigQuestionName: null,
      },
    ];
  },
  DELETE_MESSAGE() {
    // We only delete Message, so we don't need to do anything here
  },
};

export const actions = {
  fetchLearningHistory({ commit }, id) {
    return StudentService.learningHistory(id).then((response) => {
      commit('SET_STUDENT', response.data.student);
      commit('SET_MESSAGING_HISTORY', response.data.messagingHistory);
      commit('SET_LEARNING_HISTORY', response.data.learningHistory);
      return response.data;
    });
  },
  fetchWrongAnswerImages({ commit }, testResult) {
    return StudentService.testImages(testResult).then((response) => {
      commit('SET_WRONG_ANSWER_IMAGES', response.data);
      return response.data;
    });
  },
  sendMessage({ commit }, message) {
    return StudentService.sendMessage(message).then((response) => {
      let messagingHistory = response.data.messagingHistory;
      if (messagingHistory) {
        commit('SET_MESSAGING_HISTORY', response.data.messagingHistory);
      }
      let level = response.data.level;
      if (level) {
        commit('UPGRADE_STUDENT_LEVEL', level);
      }
      return response.data;
    });
  },
  deleteMessage({ commit }, messageId) {
    return StudentService.deleteMessage(messageId).then(() => {
      commit('DELETE_MESSAGE');
    });
  },
  certificatePDF({ state }, bookId) {
    const payload = {
      id: state.student.uid,
      name: state.student.name,
      grade: bookId,
    };
    return StudentService.certificatePDF(payload).then((response) => {
      const blob = new Blob([response.data]);
      const fileName = `certificate-${bookId}-${moment().format('X')}`; // format('X') is Unix Timestamp

      // Create a tag and trigger click to download url
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${fileName}.pdf`;
      link.click();
    });
  },
  updateNotPromotedBook({ commit, state }, notPromotedBook) {
    const payload = {
      index: state.notPromotedBooks.findIndex((item) => item.id === notPromotedBook.id),
      notPromotedBook: notPromotedBook,
    };
    commit('SET_NOT_PROMOTED_BOOK_AT_INDEX', payload);
  },
  addNotPromotedBook({ commit }, notPromotedBook) {
    commit('ADD_NOT_PROMOTED_BOOK', notPromotedBook);
  },
  deleteNotPromotedBook({ commit, state }, id) {
    const index = state.notPromotedBooks.findIndex((item) => item.id == id);
    commit('DELETE_NOT_PROMOTED_BOOK_AT_INDEX', index);
  },
  clearNotPromotedBooks({ commit }) {
    commit('CLEAR_NOT_PROMOTED_BOOKS');
  },
};
